export const timeHeader = (headerName, tz = 'EST') => `${headerName} (${tz})`
